import { post } from "#app/lib/fetchClient";

import { GATEWAY_PATHS } from "../api-utils";

type PostMfaAnalyzeWidgetParams = {
  signal?: AbortSignal;
};

export type PostMfaAnalyzeWidgetData = {
  loginId: string;
  authVendorId: string;
  sessionValue: string;
  widgetToken: {
    accessToken: string;
    companyId: string;
    policyId: string;
  };
};

export async function postMfaAnalyzeWidget(
  params: PostMfaAnalyzeWidgetParams,
): Promise<PostMfaAnalyzeWidgetData | null> {
  const response = await post<PostMfaAnalyzeWidgetData>(
    `${GATEWAY_PATHS.externalFundTransferService}/Mfa/Analyze/Widget`,
    {
      json: {},
      signal: params.signal,
    },
  );

  if (response.status === 204) {
    return null;
  }

  const data = await response.json();
  return data;
}
